import {getBotBonusProfile} from "../getBotBonusProfile";
import {W36_GOLD_PLUS_MIN_INTENSITY} from "../../../configs/botGoldPlus";

/**
 * Бот «золото+» волны 36: бонус действует и его интенсивность не ниже
 * «большого» (по ЧИСЛАМ бонуса, см. configs/botGoldPlus). Остальные боты —
 * без бонуса, с бонусом ниже «большого», неявные боты рейтинга — играют
 * прежним кодом дословно.
 */
export const checkIfW36GoldPlusPlayer = (player, gameType) => {
  if (!player) {
    return false;
  }
  const bonusProfile = getBotBonusProfile(player, gameType);
  // Сравнение с допуском: порог — интенсивность «большого» бонуса
  return Boolean(bonusProfile) && bonusProfile.intensity >= W36_GOLD_PLUS_MIN_INTENSITY - 1e-9;
};

/**
 * Действует ли у бота подчасть волны 36: бот золото+ и не в legacy-группе A/B
 * этой подчасти (isPreW36…Player из abTestGates).
 *
 * @param {Object} player - игрок из состояния партии
 * @param {string} gameType - тип партии (бонус локальной игры и лобби)
 * @param {function(string): boolean} isPreFeaturePlayer - legacy-гейт подчасти
 */
export const checkIfW36Feature = (player, gameType, isPreFeaturePlayer) => (
  checkIfW36GoldPlusPlayer(player, gameType) && !isPreFeaturePlayer(player.id)
);
